import { today } from 'AppReact';
import React from "react";
import { endOfDay, startOfDay, subYears } from 'date-fns';

const holder = {
  closePropertySelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.outlet({ startDate: holder.startDate, endDate: holder.endDate, selectedTimeSpan: holder.selectedTimeSpan });

      holder.internalStateSetter('isOpen', false);
      document.removeEventListener("mousedown", holder.closePropertySelector)
    }
  }
};

export default {
  'DateRangePicker.Wrapper.Header': async ({ isOpen, containerRef, isReadonly, startDate, endDate, selectedTimeSpan, selectedYear, yearListRef, monthListRef }, outlet, internalStateSetter) => {
    if (isReadonly) return;
    if (isOpen) return;
    await internalStateSetter('isOpen', true);

    let newContainerRef = containerRef;
    let newYearRef = yearListRef;
    let newMonthRef = monthListRef;

    if (!containerRef || !yearListRef || !monthListRef) {
      newContainerRef = React.createRef(null);
      newYearRef = React.createRef(null);
      newMonthRef = React.createRef(null);
      await internalStateSetter({ containerRef: newContainerRef, yearListRef: newYearRef,  monthListRef: newMonthRef });
    }

    newYearRef?.current?.children?.[selectedYear - 2000]?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });

    if (endDate?.getFullYear() === selectedYear) {
      setTimeout(function () {
        newMonthRef?.current?.children?.[endDate.getMonth()]?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      }, 800);
    }
    if (startDate?.getFullYear() === selectedYear) {
      setTimeout(function () {
        newMonthRef?.current?.children?.[startDate.getMonth()]?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      }, 800);
    }


    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = newContainerRef;
    holder.outlet = outlet;
    holder.startDate = startDate;
    holder.endDate = endDate;

    if (selectedTimeSpan === 'custom') {
      internalStateSetter({ editingDate: 'startDate' })
    }
    document.addEventListener("mousedown", holder.closePropertySelector);
  },

  'DateRangePicker.Wrapper.DropdownWrapper.BorderWrapper.CalendarWrapper.LeftSideWrapper.Buttons': ({ startDate, endDate, selectedTimeSpan }, _, internalStateSetter) => {
    holder.startDate = startDate;
    holder.endDate = endDate;
    holder.selectedTimeSpan = selectedTimeSpan;
    internalStateSetter({ startDate, endDate, selectedYear: today().getFullYear(), selectedTimeSpan });
    if (selectedTimeSpan === 'custom') {
      internalStateSetter({ editingDate: 'startDate' })
    }
  },
  'DateRangePicker.Wrapper.DropdownWrapper.BorderWrapper.CalendarWrapper.LeftSideWrapper.Reset': ({ }, _, internalStateSetter) => {
    holder.startDate = window?.first_work_order_date ? new Date(window.first_work_order_date) : startOfDay(subYears(today(), 10));
    holder.endDate = today();
    holder.selectedTimeSpan = 'allTime';
    internalStateSetter({ startDate: window?.first_work_order_date ? new Date(window.first_work_order_date) : startOfDay(subYears(today(), 10)), endDate: endOfDay(today()), selectedYear: today().getFullYear(), selectedTimeSpan: 'allTime' })
  },
  'DateRangePicker.Wrapper.DropdownWrapper.BorderWrapper.CalendarWrapper.RightSideWrapper.ListWrapper.YearList.Year': ({ year, monthListRef, endDate, startDate }, _, internalStateSetter) => {
    internalStateSetter({ selectedYear: year });

    if (endDate?.getFullYear() === year) {
      monthListRef?.current?.children?.[endDate.getMonth()]?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    } else if (startDate?.getFullYear() === year) {
      monthListRef?.current?.children?.[startDate.getMonth()]?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    } else {
      monthListRef?.current?.children?.[0]?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }
  },
  'DateRangePicker.Wrapper.DropdownWrapper.BorderWrapper.CalendarWrapper.RightSideWrapper.ListWrapper.ListWrapper.Month': ({ selectedDate, startDate, endDate, selectedTimeSpan, editingDate }, _, internalStateSetter) => {
    if (selectedTimeSpan !== 'custom') {
      if (selectedDate > endDate) {
        holder.startDate = selectedDate;
        holder.endDate = selectedDate;
        holder.selectedTimeSpan = 'custom';
        internalStateSetter({ startDate: selectedDate, editingDate: 'endDate', endDate: selectedDate, selectedTimeSpan: 'custom' });
      } else {
        holder.startDate = selectedDate;
        holder.selectedTimeSpan = 'custom';
        internalStateSetter({ startDate: selectedDate, editingDate: 'endDate', selectedTimeSpan: 'custom' });
      }
    } else {
      if (editingDate === 'startDate') {
        if (selectedDate > endDate) {
          holder.startDate = selectedDate;
          holder.endDate = selectedDate;
          holder.selectedTimeSpan = 'custom';
          internalStateSetter({ startDate: selectedDate, editingDate: 'endDate', endDate: selectedDate, selectedTimeSpan: 'custom' });
        } else {
          holder.startDate = selectedDate;
          holder.selectedTimeSpan = 'custom';
          internalStateSetter({ startDate: selectedDate, editingDate: 'endDate', selectedTimeSpan: 'custom' });
        }
      } else {
        if (selectedDate < startDate) {
          holder.startDate = selectedDate;
          holder.endDate = selectedDate;
          holder.selectedTimeSpan = 'custom';
          internalStateSetter({ startDate: selectedDate, editingDate: null, endDate: selectedDate, selectedTimeSpan: 'custom' });
        } else {
          holder.endDate = selectedDate;
          holder.selectedTimeSpan = 'custom';
          internalStateSetter({ endDate: selectedDate, editingDate: null, selectedTimeSpan: 'custom' });
        }
      }
    }
  },
  'DateRangePicker.Wrapper.Header.SearchTerm': ({ }, outlet, internalStateSetter) => {
    outlet({ startDate: window?.first_work_order_date ? new Date(window.first_work_order_date) : startOfDay(subYears(today(), 10)), endDate: today(), selectedTimeSpan: 'allTime' })
    internalStateSetter({ startDate: window?.first_work_order_date ? new Date(window.first_work_order_date) : startOfDay(subYears(today(), 10)), endDate: endOfDay(today()), selectedYear: today().getFullYear(), selectedTimeSpan: 'allTime' })
  },
  'DateRangePicker.Wrapper.CustomHeader': ({ selectedDate, action, startDate, endDate }, _, internalStateSetter) => {
    if (action === 'selectStartDate') {
      internalStateSetter({ editingDate: 'startDate' })
    }
    if (action === 'selectEndDate') {
      internalStateSetter({ editingDate: 'endDate' })
    }
    if (action === 'changeStartDate') {
      holder.startDate = selectedDate;
      holder.endDate = selectedDate > endDate ? selectedDate : endDate;
      holder.selectedTimeSpan = 'custom';
      internalStateSetter({ startDate: selectedDate, endDate: selectedDate > endDate ? selectedDate : endDate, selectedTimeSpan: 'custom' });
    }
    if (action === 'changeEndDate') {
      holder.endDate = selectedDate;
      holder.startDate = selectedDate < startDate ? selectedDate : startDate;
      holder.selectedTimeSpan = 'custom';
      internalStateSetter({ endDate: selectedDate, startDate: selectedDate < startDate ? selectedDate : startDate, selectedTimeSpan: 'custom' });
    }
  }
}